/** Sentinel for legacy USER# partition — never send as real X-Workspace-Id UUID. */
export const PERSONAL_WORKSPACE_ID = 'personal';

let activeWorkspaceId = null;

export function setActiveWorkspaceId(id) {
  const resolved =
    id === PERSONAL_WORKSPACE_ID || id === '' ? null : id || null;
  activeWorkspaceId = resolved;
  try {
    if (typeof window === 'undefined') return;
    if (id) {
      window.localStorage?.setItem?.('fokus_workspace_id', id);
    } else {
      window.localStorage?.removeItem?.('fokus_workspace_id');
    }
  } catch {
    /* ignore */
  }
}

export function getActiveWorkspaceId() {
  return activeWorkspaceId;
}

/**
 * Header for API calls that must hit the same partition as campaigns/docs.
 * Named workspace → send it. Personal / missing → omit (server uses Personal).
 * Pass a pin when the operation started, so a mid-flight workspace switch
 * cannot send the file to the new room.
 */
export function workspaceApiHeaders(pinnedWorkspaceId) {
  const raw =
    pinnedWorkspaceId !== undefined ? pinnedWorkspaceId : getActiveWorkspaceId();
  const wsId =
    !raw || raw === PERSONAL_WORKSPACE_ID || raw === '' ? null : raw;
  return wsId ? { 'X-Workspace-Id': wsId } : {};
}

/** The raw id stored in localStorage (may be 'personal'). */
export function getStoredWorkspacePreference() {
  try {
    if (typeof window === 'undefined') return null;
    return window.localStorage?.getItem?.('fokus_workspace_id') || null;
  } catch {
    return null;
  }
}

export function hydrateWorkspaceIdFromStorage() {
  try {
    if (typeof window === 'undefined') return;
    const id = window.localStorage?.getItem?.('fokus_workspace_id');
    if (!id || id === PERSONAL_WORKSPACE_ID) {
      activeWorkspaceId = null;
    } else {
      activeWorkspaceId = id;
    }
  } catch {
    /* ignore */
  }
}
